import { render, staticRenderFns } from "./spiner.vue?vue&type=template&id=7dcffd81&scoped=true"
import script from "./spiner.vue?vue&type=script&lang=js"
export * from "./spiner.vue?vue&type=script&lang=js"
import style0 from "./spiner.vue?vue&type=style&index=0&id=7dcffd81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcffd81",
  null
  
)

export default component.exports